// @flow

import React from "react";
import { localize } from "redux-i18n";
import debounce from "lodash.debounce";
import { SchemaForm, View } from "@components";

import schemas, { type Schemas } from "./schemas";

type Props = $Exact<{
  data: ?Object,
  schema: Object | null,
  onRef: (ref: *) => *,
  onChange?: (data: Object) => void,
  onSubmit?: (data: Object) => void,
  ...PropsFromLocalize,
}>;

export class AlertCriteriaForm extends React.Component<Props> {
  form: *;

  get alertType() {
    return (this.props.data || {}).alertType;
  }

  get schemas(): ?Schemas {
    return this.alertType ? schemas[this.alertType] : null;
  }

  render() {
    if (!this.schemas) {
      return null;
    }
    const { schema, uiSchema } = this.schemas;

    return (
      <View className="gs-container">
        {this.props.schema && schema && uiSchema && (
          <SchemaForm
            ref={this.formRef}
            formData={this.props.data || {}}
            schema={schema(this.props.schema) || {}}
            uiSchema={uiSchema(this.props.t) || {}}
            onChange={this.props.onChange}
            onSubmit={this.props.onSubmit}
            externalSubmit
          />
        )}
      </View>
    );
  }
}

export default localize()(AlertCriteriaForm);
